import { envConfig } from '@infrastructure/envConfig'

export class ClinicsUrlProvider {
    baseUrl = `${envConfig.API_URL}`

    clinicUrl = id => `${this.baseUrl}/clinics/${id}`
}
